import H5 from 'UIComponents/elements/headings/H5';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import TriggerTypeButton from 'automation-ui-enrollment/components/eventEnrollment/TriggerTypeButton';
import useHasWebhookTriggersAccess from 'automation-ui-enrollment/hooks/useHasWebhookTriggersAccess';
import Small from 'UIComponents/elements/Small';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { DATASET_FUNCTIONALITY } from 'automation-ui-enrollment/constants/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TriggerTypeButtonList = ({
  objectTypeId,
  onChange,
  selectedTriggerType,
  readOnly
}) => {
  const {
    hasWebhookTriggersScope,
    webhookTriggersAllowedForObjectType
  } = useHasWebhookTriggersAccess(objectTypeId);
  const hasDatasetTriggersAccess = useIsUngated(DATASET_FUNCTIONALITY);
  const eventTriggersButton = /*#__PURE__*/_jsx(TriggerTypeButton, {
    illustrationName: "events",
    selected: selectedTriggerType === 'EVENT',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.eventTriggersTitle"
    }),
    info: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      objectTypeId: objectTypeId,
      baseLangKey: "automation-ui-enrollment.redesign.enrollSelection.eventTriggersInfo_cob",
      isJsx: true,
      elements: {
        Bold: 'b'
      }
    }),
    onClick: () => {
      onChange('EVENT');
    },
    disabled: readOnly
  });
  const listTriggersButton = /*#__PURE__*/_jsx(TriggerTypeButton, {
    illustrationName: "segmented-lists",
    selected: selectedTriggerType === 'LIST',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.listTriggersTitle"
    }),
    info: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.listTriggersInfo"
    }),
    onClick: () => {
      onChange('LIST');
    },
    disabled: readOnly
  });
  const scheduledTriggersButton = /*#__PURE__*/_jsx(TriggerTypeButton, {
    illustrationName: "schedule",
    selected: selectedTriggerType === 'SCHEDULED',
    upgradePoint: "workflows-trigger-scheduled",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.scheduledTriggersTitle"
    }),
    info: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.scheduledTriggersInfo"
    }),
    onClick: () => {
      onChange('SCHEDULED');
    },
    disabled: readOnly
  });
  const webhookTriggersButton = /*#__PURE__*/_jsx(TriggerTypeButton, {
    illustrationName: "api",
    selected: selectedTriggerType === 'WEBHOOK',
    locked: !hasWebhookTriggersScope,
    upgradePoint: "webhook-triggers-selection-panel",
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.webhookTriggersTitle"
    }),
    info: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      objectTypeId: objectTypeId,
      baseLangKey: "automation-ui-enrollment.redesign.enrollSelection.webhookTriggersInfo_cob",
      isJsx: true,
      elements: {
        Bold: 'b'
      }
    }),
    onClick: () => {
      onChange('WEBHOOK');
    },
    disabled: readOnly
  });
  const datasetTriggersButton = /*#__PURE__*/_jsx(TriggerTypeButton, {
    illustrationName: "operations-hub-data-sync",
    selected: selectedTriggerType === 'DATASET',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.datasetTriggersTitle"
    }),
    info: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.redesign.enrollSelection.datasetTriggersInfo"
    }),
    onClick: () => {
      onChange('DATASET');
    }
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      className: "display-inline m-right-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollSelection.selection"
      })
    }), /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.review.optional"
      })
    }), eventTriggersButton, listTriggersButton, scheduledTriggersButton, webhookTriggersAllowedForObjectType && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        className: "p-top-2",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "automation-ui-enrollment.redesign.enrollSelection.advancedOptions"
        })
      }), webhookTriggersButton]
    }), hasDatasetTriggersAccess && datasetTriggersButton]
  });
};
export default TriggerTypeButtonList;